import { NgModule } from '@angular/core';
import { CommonModule } from "@angular/common";

import { PriceFilter } from './pipes/price.filter.pipe';
import { CategoryFilter } from './pipes/category.filter.pipe';
import { ItemFilter } from './pipes/item.filter.pipe';
import { ImgFilter } from './pipes/image.filter.pipe';
import { TruncateFilter } from './pipes/truncate.pipe';
import { RangeFilter } from './pipes/range.pipe';
import { SizeFilter } from './pipes/size.pipe';
import { BooleanFilter } from './pipes/boolean.pipe';
import { SearchFilterPipe } from './pipes/search.filter.pipe';
import { OrderPipe } from './pipes/orderby.pipe';
import { IdFilter } from './pipes/id.filter.pipe';
import { HiddenFilter } from './pipes/hidden.pipe';
import { OwnedFilter } from './pipes/owned.pipe';

@NgModule({
  declarations:[ PriceFilter, CategoryFilter, ItemFilter, TruncateFilter, BooleanFilter, RangeFilter, SizeFilter, ImgFilter, SearchFilterPipe, OrderPipe, IdFilter, HiddenFilter, OwnedFilter ],
  imports:[ CommonModule ],
  exports:[ PriceFilter, CategoryFilter, ItemFilter, TruncateFilter, BooleanFilter, RangeFilter, SizeFilter, ImgFilter, SearchFilterPipe, OrderPipe, IdFilter, HiddenFilter, OwnedFilter ]
})

export class MainPipeModule{}


// WEBPACK FOOTER //
// C:/Users/Asylum/identity-vagrant/src/asylum-idenetity/src/app/app.pipes.ts